
const apiBaseUrl = import.meta.env.VITE_API_URL || 'https://api.agromate.dk/v1';

const config = {
  apiBaseUrl,
};

export default config;
